import {
  affiliationTypes,
  DropDownMenu,
  professionalDesignations,
  RadioButtonGroup,
  required,
} from 'entoro-shared';
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

const InvestorAffiliationsForm = reduxForm({
  form: 'investorAffiliations',
  enableReinitialize: true,
})((props) => {
  const { handleSubmit, submitting, update } = props;

  return (
    <div className='w-clearfix w-form'>
      <form onSubmit={handleSubmit(update)}>
        <div className='content-spacer'>
          <div className='column-fields w-row'>
            <div className='column-4 w-col w-col-7'>
              <Field
                component={RadioButtonGroup}
                validate={[required]}
                name='affiliationType'
                label='Affiliation Type'
                options={affiliationTypes.options}
                required
              />
            </div>
            <div className='column-5 w-col w-col-5' />
          </div>
        </div>
        <div className='column-fields w-row'>
          <div className='column-4 w-col w-col-6'>
            <div className='_26-black'>Professional Designation</div>
            <div className='grey-regular max-width'>
              Select a Designation if Applicable
            </div>
            <Field
              component={DropDownMenu}
              name='professionalDesignation'
              label='Professional Designation'
              options={professionalDesignations.options}
            />
          </div>
          <div className='column-5 w-col w-col-6' />
        </div>
        <div className='full-line bottom' />
        <input
          type='submit'
          value='Save & Continue'
          disabled={submitting}
          className={`button-2 w-button ${submitting ? 'btn-disabled' : ''}`}
        />
      </form>
    </div>
  );
});

const mapStateToProps = (state) => ({
  initialValues: state.investorUser,
});

export default connect(mapStateToProps)(InvestorAffiliationsForm);



// WEBPACK FOOTER //
// ./src/components/Account/InvestorAffiliations/InvestorAffiliationsForm.js